import { Box, Divider, Grid, Hidden, makeStyles, Typography } from "@material-ui/core";
import { ArticleSummaryCard } from "./article-summary-card";
import { useTranslation } from "react-i18next";
import { useApplicationParams } from '../../hooks/app-params';
import { useMemo } from "react";

const useStyles = makeStyles(theme => ({
    boxWrapper: {
        padding: '0 35px !important'
    },
    boxContentWrapper: {
        padding: '15px !important'
    },
    headerLabel: {
        textTransform: 'uppercase'
    }
}))

export const ArticlesSummary = ({
    articles
}) => {
    const classes = useStyles();
    const {t} = useTranslation();
    const appParams = useApplicationParams();

    const quantityInTotal = articles.map(a => a?.dropdetailsdata?.deliveredQuantityIn ?? 0).reduce((prevValue, currentValue) => prevValue + currentValue, 0);
    const quantityOutTotal = articles.map(a => a?.dropdetailsdata?.deliveredQuantityOut ?? 0).reduce((prevValue, currentValue) => prevValue + currentValue, 0);

    const labelOut = useMemo(() => {
        return t(appParams?.articleInventoryNoLimits ? 'QuantityOut' : 'Used');
    }, [t, appParams?.articleInventoryNoLimits])

    return (
        <>
            <Box className={classes.boxWrapper}>
                <Grid container alignItems="center" spacing={2}>
                    <Grid item xs={12} sm={8} md={10}>
                        <Typography variant="subtitle1" className={classes.headerLabel}>
                            {t('Article')}
                            <Hidden smUp> ({t('In')} / {labelOut})</Hidden>
                        </Typography>
                    </Grid>
                    <Hidden xsDown>
                        <Grid item xs={6} sm={2} md={1}>
                            <Grid container justifyContent="center">
                                <Typography variant="subtitle1" className={classes.headerLabel}>{t('In')}</Typography>
                            </Grid>
                        </Grid>
                        <Grid item xs={6} sm={2} md={1}>
                            <Grid container justifyContent="center">
                                <Typography variant="subtitle1" className={classes.headerLabel}>{labelOut}</Typography>
                            </Grid>
                        </Grid>
                    </Hidden>
                </Grid>
            </Box>
            <Box bgcolor="#F1F1F1" borderRadius={10} className={classes.boxContentWrapper}>
                <Grid container spacing={2}>
                    {articles.map((article, i) => (
                        <Grid key={`article-${i}`} item xs={12}>
                            <ArticleSummaryCard article={article} 
                                quantityIn={article?.dropdetailsdata?.deliveredQuantityIn}
                                quantityOut={article?.dropdetailsdata?.deliveredQuantityOut} />
                        </Grid>
                    ))}
                </Grid>
                <Divider />
                <Grid container className={classes.boxContentWrapper} alignItems="center" spacing={2}>
                    <Grid item xs={12} sm={8} md={10}>
                        <Typography variant="subtitle1">
                            {t('Total')}
                            <Hidden smUp> ({quantityInTotal} / {quantityOutTotal})</Hidden>
                        </Typography>
                    </Grid>
                    <Hidden xsDown>
                        <Grid item xs={6} sm={2} md={1}>
                            <Grid container justifyContent="center">
                                <Typography variant="inherit">{quantityInTotal}</Typography>
                            </Grid>
                        </Grid>
                        <Grid item xs={6} sm={2} md={1}>
                            <Grid container justifyContent="center">
                                <Typography variant="inherit">{quantityOutTotal}</Typography>
                            </Grid>
                        </Grid>
                    </Hidden>
                </Grid>
            </Box>
        </>
    );
    
}